// Recovered compiled webpack factory 82073. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "HeadManagerContext", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }));
  let n = r(28140)._(r(12115)).default.createContext({});
}
